import { Field, useFormikContext } from "formik";
import React, { useState } from "react";
import { components } from "react-select";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useNavigate } from "react-router-dom";
import DownArrowIcon from "../../assets/icons/down-arrow-icon";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import "./form.css";

const SearchField = ({
  isRequired = true,
  name,
  cusType = "Customer",
  handleCreateOption,
  loadOptions,
  type = "number",
  isLabelReq = true,
  onChange = () => {},
  placeholder = "select and add...",
  Icon = <DownArrowIcon />,
  label = "Phone Number",
  disabled = false,
  autoFocus = false,
  labelClass = "flex gap-1 whitespace-nowrap text-[var(--search-input-label-color)]  text-[length:--search-label-font-size] font-[var(--search-label-font-weight)]",
  minWidth = "",
  isValidNewOption = false,
  className = "",
  maxlength = 100,
  menuPosition = "",
  lower=false,
  showCreateOption = true,
}) => {
  const { values: formValues } = useFormikContext();

  const [inputValue, setInputValue] = useState(
    formValues?.phone === null ? "" : ""
  );

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {Icon}
      </components.DropdownIndicator>
    );
  };
  const navigate = useNavigate();
  const NoOptionsMessage = ({ inputValue, ...props }) => (
    <button
      onClick={() => navigate("/admin/add-customer")}
      className="py-1 cursor-pointer"
    >
      <span className="text-primary text-sm px-3">
        <span className="fs_18 pr-1">+</span> New {cusType}
      </span>
    </button>
  );
  // const handleNumberInput = (e) => {
  //   if (/^[A-Za-z]$/.test(e.key)) {
  //     e.preventDefault();
  //   }
  // };

  const handleNumberInput = (e) => {
    // Allow Ctrl+V (or Cmd+V on Mac) for pasting
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "v") {
      return; // Allow pasting
    }

    // Prevent alphabetic characters during typing
    if (/^[A-Za-z]$/.test(e.key)) {
      e.preventDefault();
    }
  };
  const onKeyDownHandler = type === "number" ? handleNumberInput : undefined;
  // const handleInputChange = (newValue, { action }) => {
  //   if (action === "input-change" && newValue.length <= maxlength) {
  //     const filtered = newValue.replace(/[^a-zA-Z0-9 ]/g, "");
  //     if (filtered.length <= maxlength) {
  //       setInputValue(filtered);
  //     }
  //     // setInputValue(newValue);
  //   }
  // };

  const handleInputChange = (newValue, { action }) => {
    if (action === "input-change") {
      const filtered = newValue.replace(/[^a-zA-Z0-9 ]/g, "");
      if (filtered.length <= maxlength) {
        setInputValue(filtered);
      }
      // Return filtered value so react-select uses only allowed input
      return filtered;
    }
    // For other actions, e.g., menu close, etc.
    return newValue;
  };

  const handleChange = (selectedOption, actionMeta) => {
    if (actionMeta?.action === "clear") {
      setInputValue("");
    }
    onChange(selectedOption, actionMeta);
  };
  return (
    <Field name={name}>
      {({ field }) => (
        <>
          <div className="flex flex-col">
            {isLabelReq && (
              <label
                style={{
                  minWidth: minWidth,
                  minHeight: "1.2rem",
                }}
                className={`${labelClass} `}
              >
                {label}
                {isRequired && <StarIcon />}
              </label>
            )}
            <AsyncCreatableSelect
              // inputValue={inputValue} //newly added
              onInputChange={handleInputChange} //newly added
              {...(!formValues[name]
                ? { inputValue, onInputChange: handleInputChange }
                : {})}
              menuPlacement="auto"
              isValidNewOption={() => isValidNewOption}
              autoFocus={autoFocus}
              onKeyDown={onKeyDownHandler}
              name={name}
              isClearable
              value={formValues[name]}
              components={{
                ...components,
                DropdownIndicator,
                ...(showCreateOption ? { NoOptionsMessage } : {}),
              }}
              placeholder={placeholder}
              type={type}
              menuPosition={menuPosition}
              className={`w-full ${lower ? "z-19" : "z-20"} border-radius ${className}`}
              styles={customStyles}
              {...field}
              onCreateOption={handleCreateOption}
              onChange={handleChange} // Pass the handleChange function
              loadOptions={loadOptions}
              isDisabled={disabled}
            />
          </div>
          {/* <div
            style={{
              height: "1rem",
            }}
            className={`text-right w-full fs_12 ${errorClass}`}
          >
            {isRequired && <ErrorMsg name={name} />}
          </div> */}
        </>
      )}
    </Field>
  );
};
export default SearchField;
const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--search-input-bg)",
    color: "var(--search-input-color)",
    fontSize: "var(--search-input-font-size)",
    fontWeight: "var(--search-input-font-weight)",
    borderColor: state.isFocused
      ? "var(--search-input-focus)"
      : "var(--search-input-border)",
    boxShadow: "none",
    borderRadius: "6px",
    padding: "0",
    margin: "0",
    minHeight: "38px",
    // "&:hover": {
    //   borderColor: "var(--search-input-focus)",
    // },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "3px 6px",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.data.color ? state.data.color : "var(--search-input-color)",
    backgroundColor: state.isSelected
      ? "#e5ecffb2"
      : state.isFocused
      ? "#0000002E"
      : "transparent",
    borderBottom: "1px solid #F5F5F5",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--search-place-font-size)",
    fontWeight: "var(--search-place-font-weight)",
    "&:hover": {
      backgroundColor: "#0000002E",
    },
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "var(--search-place-color)",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--search-place-font-size)",
    fontWeight: "var(--search-place-font-weight)",
    opacity: "0.9",
  }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "var(--search-input-color)",
    fontSize: "var(--search-input-font-size)",
    fontWeight: "var(--search-input-font-weight)",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  dropdownIndicator: () => ({ display: "none" }),
};
